<template>
  <create-course-layout  title="ساخت دوره" :submitFunction="createCourse"/>
</template>
<script>
import {mapActions} from 'vuex';
import CreateCourseLayout from "./CreateLayout.vue";


export default {
  name: "CreateCourse",
  components: {CreateCourseLayout},
    methods: {
    ...mapActions({
      createCourse:"Course/createCourse"
    })
  }
};
</script>
<style scoped>

</style>